import { createStore, persist } from 'easy-peasy';
import auth from './auth';
import clients from './clients';
import releases from './releases';
import builds from './builds';
import groups from './groups';
import users from './users';

const store = createStore(persist({ auth, clients, releases, builds, groups, users }));

export default store;
